import { url } from '..//config/url.js'
import { mode } from '..//config/mode.js'

export function initMap(stat){
    stat.cesiumInstance.viewer.scene.mode = Cesium.SceneMode.SCENE3D 
    stat.cesiumInstance.viewer.scene.globe.showGroundAtmosphere = true
    stat.cesiumInstance.viewer.scene.globe.enableLighting = true
    stat.cesiumInstance.viewer.scene.fog.enabled = false
    stat.cesiumInstance.viewer.scene.skyAtmosphere =  new Cesium.SkyAtmosphere() 
    stat.cesiumInstance.viewer.resolutionScale = 1
    stat.cesiumInstance.viewer.useBrowserRecommendedResolution =  true
    stat.cesiumInstance.viewer.showRenderLoopErrors = false
    stat.cesiumInstance.viewer.scene.screenSpaceCameraController.minimumZoomDistance = 5000
    
    stat.cesiumInstance.viewer.screenSpaceEventHandler.setInputAction(function onLeftClick(movement){
    
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK)

    stat.cesiumInstance.viewer.screenSpaceEventHandler.setInputAction(function onLeftDblClick(movement){
        stat.clickMapEntityHandler(stat, stat.cesiumInstance.viewer.scene.pick(movement.position))
    }, Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
    
    stat.cesiumInstance.viewer.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK)
    
    stat.cesiumInstance.viewer.camera.setView({destination: Cesium.Rectangle.fromDegrees(
        126.5,
        31.5,
        128.5,
        39
    )})
    
    let handler = new Cesium.ScreenSpaceEventHandler(stat.cesiumInstance.viewer.scene.canvas)
    handler.setInputAction(function (movement) {
      const cartesian = stat.cesiumInstance.viewer.camera.pickEllipsoid(
        movement.endPosition,
        stat.cesiumInstance.viewer.scene.globe.ellipsoid
      )
      if (cartesian) {
        const cartographic = Cesium.Cartographic.fromCartesian(
          cartesian
        )
        const longitudeString = Cesium.Math.toDegrees(
          cartographic.longitude
        ).toFixed(5)
        const latitudeString = Cesium.Math.toDegrees(
          cartographic.latitude
        ).toFixed(5)
        
        stat.mouseLat = latitudeString
        stat.mouseLng = longitudeString
      } 
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE)


    loadDefaultLayer(stat)

    setTimeout(()=>{
        stat.startDataProcess(stat)
    },500)
    
}

export function load3dBuildings(stat){
  
    stat.cesiumInstance.viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
        url : url[mode.where].buildingServer + 'seoul/gangseo-gu/tileset.json',
        skipLevelOfDetail : true,
        baseScreenSpaceError : 1024,
        skipScreenSpaceErrorFactor : 16,
        skipLevels : 1,
        immediatelyLoadDesiredLevelOfDetail : false,
        loadSiblings : false,
        cullWithChildrenBounds : true,
        show : stat.isWorldTerrainEnabled
    }))

   stat.cesiumInstance.viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
        url : url[mode.where].buildingServer + 'seoul/yangcheon-gu/tileset.json',
        skipLevelOfDetail : true,
        baseScreenSpaceError : 1024,
        skipScreenSpaceErrorFactor : 16,
        skipLevels : 1,
        immediatelyLoadDesiredLevelOfDetail : false,
        loadSiblings : false,
        cullWithChildrenBounds : true,
        show : stat.isWorldTerrainEnabled
    }))

    stat.cesiumInstance.viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
        url : url[mode.where].buildingServer + 'gimpo-si/tileset.json',
        skipLevelOfDetail : true,
        baseScreenSpaceError : 1024,
        skipScreenSpaceErrorFactor : 16,
        skipLevels : 1,
        immediatelyLoadDesiredLevelOfDetail : false,
        loadSiblings : false,
        cullWithChildrenBounds : true,
        show : stat.isWorldTerrainEnabled
    })) 
}

export function loadDefaultLayer(stat){
    setTimeout(()=>{
        let satProvider = new Cesium.WebMapTileServiceImageryProvider({
            url : url[mode.where].satMapServer,
            maximumLevel: 19,
        })
        
        let baseProvider = new Cesium.WebMapTileServiceImageryProvider({
            url : url[mode.where].basicMapServer,
            maximumLevel: 19,
        })
    
        stat.cesiumInstance.viewer.imageryLayers.addImageryProvider(satProvider) 
        stat.cesiumInstance.viewer.imageryLayers.addImageryProvider(baseProvider) 
    
        changeTileLayer(stat,'Sat')

    },1000)
}

export function getColor (colorName, alpha) {
    var color = Cesium.Color[colorName.toUpperCase()]
    return Cesium.Color.fromAlpha(color, parseFloat(alpha))
}

export function loadNoiseLine(stat){
    const noiseColor = {
        "75" : Cesium.Color.MEDIUMBLUE.withAlpha(0.25),
        "80" : Cesium.Color.HOTPINK.withAlpha(0.35),
        "85" : Cesium.Color.ORANGERED.withAlpha(0.45),
        "90" : Cesium.Color.PALEGREEN.withAlpha(0.55),
        "95" : Cesium.Color.LINEN.withAlpha(0.65)
    }
 
    const noiseLineColor = {
        "75" : Cesium.Color.MEDIUMBLUE,
        "80" : Cesium.Color.HOTPINK,
        "85" : Cesium.Color.ORANGERED,
        "90" : Cesium.Color.PALEGREEN,
        "95" : Cesium.Color.LINEN
    }

    for(let i in stat.noiseLine){
        let parser = new DOMParser()
        let xmlParsed = parser.parseFromString(stat.noiseLine[i], "application/xml")
        let xml = xmlParsed.documentElement
        let posStr = ""
        if(xml.getElementsByTagName('gml:posList')[0].textContent){
            posStr = xml.getElementsByTagName('gml:posList')[0].textContent
            let posList =  posStr.toString().split(" ")
            stat.cesiumInstance.viewer.entities.add({
                name: "noiseLine",
                show: true,
                polygon : {
                    hierarchy : Cesium.Cartesian3.fromDegreesArray(posList),
                    height : 0,
                    material : noiseColor[i],
                    outline : true,
                    outlineColor : noiseLineColor[i],
                }
            }) 
        } 
    }
}

export function loadNoiseSensorPoint(stat){
    for(let i in stat.noiseSensorPoint.FeatureCollection.featureMember){
        let latlng = stat.noiseSensorPoint.FeatureCollection.featureMember[i].VIEW_MSRSTN_001.GEOM.Point.pos.split(' ')
        let lat = latlng[1]
        let lng = latlng[0]

        let nmtNo = stat.noiseSensorPoint.FeatureCollection.featureMember[i].VIEW_MSRSTN_001.NMT_NO.toString()
        if( nmtNo.length === 1 ){
            nmtNo = "0" + nmtNo
        }

        stat.cesiumInstance.viewer.entities.add({
            id : stat.noiseSensorPoint.FeatureCollection.featureMember[i].VIEW_MSRSTN_001.ARP_SE + stat.noiseSensorPoint.FeatureCollection.featureMember[i].VIEW_MSRSTN_001.NMT_NO.toString(),
            name:'noiseSensorPoint',
            description : stat.noiseSensorPoint.FeatureCollection.featureMember[i].VIEW_MSRSTN_001,
            show: stat.isNoiseSensorPointVisible, 
            position: Cesium.Cartesian3.fromDegrees(lng, lat, 10),
            label: {
                text: '',
                scaleByDistance: new Cesium.NearFarScalar(1.5e2, 0.5, 1.5e7, 0.25),
                showBackground : true, 
                backgroundColor : Cesium.Color.BLACK
            },
            billboard: {
              image: stat.airportIcon,
              scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1, 1.5e7, 0.75),
            },
        })
    }
}

export function toggleAirportMarker(stat, boolean){
    for(let i in stat.cesiumInstance.viewer.entities.values){
        if(stat.cesiumInstance.viewer.entities.values[i].name==='airport'){
            stat.cesiumInstance.viewer.entities.values[i].show = boolean
        }
    }
}

export function toogleEntity(stat, entity, boolean){
    for(let i in stat.cesiumInstance.viewer.entities.values){
        if(stat.cesiumInstance.viewer.entities.values[i].name===entity){
            if(entity === 'track'){
                stat.cesiumInstance.viewer.entities.values[i].show = boolean
            }
            if(entity === 'trackHistory'){
                for(let i in stat.cesiumInstance.viewer.entities.values){
                  if(stat.cesiumInstance.viewer.entities.values[i]['_name']===entity){
                      if(boolean){
                        if(stat.cesiumInstance.viewer.entities.values[i]['_historyType']==='wall'){
                            stat.cesiumInstance.viewer.entities.values[i].show = true
                        } else if(stat.cesiumInstance.viewer.entities.values[i]['_historyType']==='polyline1'){
                            stat.cesiumInstance.viewer.entities.values[i].show = true
                        } else if(stat.cesiumInstance.viewer.entities.values[i]['_historyType']==='polyline2'){
                            stat.cesiumInstance.viewer.entities.values[i].show = false
                        }
                      } else {
                        stat.cesiumInstance.viewer.entities.values[i].show = false
                      }
                  }
                }
            }
        }
    }
}

export function toogleNoiseLine(stat, boolean){
    for(let i in stat.cesiumInstance.viewer.entities.values){
        if(stat.cesiumInstance.viewer.entities.values[i].name==='noiseLine'){
            stat.cesiumInstance.viewer.entities.values[i].show = boolean
        }
    }
}

export function toogleNoisePoint(stat, boolean){
    for(let i in stat.cesiumInstance.viewer.entities.values){
        if(stat.cesiumInstance.viewer.entities.values[i].name==='noiseSensorPoint'){
            stat.cesiumInstance.viewer.entities.values[i].show = boolean
        }
    }
}

export function changeTileLayer(stat,layer){
    stat.currentDefaultLayer = layer

    if (layer === 'Base'){
        stat.cesiumInstance.viewer.imageryLayers['_layers'][2].show = false
        stat.cesiumInstance.viewer.imageryLayers['_layers'][3].show = true
    } else if (layer === 'Sat'){
        stat.cesiumInstance.viewer.imageryLayers['_layers'][3].show = false
        stat.cesiumInstance.viewer.imageryLayers['_layers'][2].show = true
    }
}

export function getPosition (data){
    let newHeight = 0
    if(data.height){
        newHeight = data.height
    } else { 
        newHeight = 0 
    }
    return Cesium.Cartesian3.fromDegrees(Number.parseFloat(data.lon), Number.parseFloat(data.lat), newHeight)
}

export function getHpr(a,b,c){
    return new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(a), b, c)
}

export function getOrientation(position,hpr){
    return Cesium.Transforms.headingPitchRollQuaternion(position,hpr)
}
